import { render, staticRenderFns } from "./SendFormModal.vue?vue&type=template&id=4b4a453e&scoped=true&"
import script from "./SendFormModal.vue?vue&type=script&lang=ts&"
export * from "./SendFormModal.vue?vue&type=script&lang=ts&"
import style0 from "./SendFormModal.vue?vue&type=style&index=0&id=4b4a453e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4a453e",
  null
  
)

export default component.exports